import {clearBeamsClient, initBeamsClient} from "../include/Pusher";

let user = null;
let refreshInterval = null;

const check = function () {
    return user !== null;
};

const stopRefreshing = function () {
    clearInterval(refreshInterval);
    refreshInterval = null;
};

const refreshUser = function () {
    return new Promise((fulfill, reject) => {
        window.axios.get('/api/auth/me').then(xhr => {
            user = xhr.data;
            initBeamsClient(user);
            fulfill(xhr.data);
        }).catch(reject);
    });
};

const startRefreshing = function () {
    stopRefreshing();
    refreshInterval = setInterval(refreshUser, 60 * 1000);
};

const logout = function () {
    stopRefreshing();
    clearBeamsClient();
    user = null;

    return window.axios.post('/api/auth/logout').catch(function () {});
};

const getUser = function () {
    return new Promise((fulfill, reject) => {
        if (user) {
            fulfill(user);

            return;
        }

        refreshUser().then(fulfill).catch(reject);
    });
};

const refreshToken = function () {
    return new Promise((fulfill, reject) => {
        window.axios.post('/api/auth/refresh').then(() => {
            fulfill();
        }).catch((error) => {
            logout();
            reject(error);
        });
    });
};

const login = function (email, password) {
    return new Promise((fulfill, reject) => {
        window.axios.post('/api/auth/login', {
            email: email,
            password: password,
        })
            .then((xhr) => {
                if (xhr.status === 200) {
                    startRefreshing();
                    refreshUser().then(function () {
                        fulfill(xhr);
                    }).catch(reject);
                } else {
                    logout();
                    reject('Login failed');
                }
            })
            .catch(error => {
                logout();
                reject(error);
            });
    });
};

const hasReadableAccessToken = function () {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        if (cookies[i].trim().indexOf('access_token=') === 0) {
            return true;
        }
    }

    return false;
};

const expireLegacyJsTokenCookie = function () {
    document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'access_token=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; Secure; SameSite=Lax';
};

const startSession = function () {
    refreshUser().then(function () {
        startRefreshing();
    }).catch(function () {
        user = null;
    });
};

const init = function () {
    // Pre-HttpOnly sessions stored a JS-readable access_token. Refresh once so the
    // server overwrites it with HttpOnly, then drop any leftover visible copy.
    if (hasReadableAccessToken()) {
        window.axios.post('/api/auth/refresh').then(function () {
            expireLegacyJsTokenCookie();
            startSession();
        }).catch(function () {
            expireLegacyJsTokenCookie();
            startSession();
        });

        return;
    }

    startSession();
};

export default {
    get user() {
        return user;
    },
    get refreshInterval() {
        return refreshInterval;
    },
    init,
    login,
    logout,
    check,
    getUser,
    refreshUser,
    refreshToken,
    startRefreshing,
    stopRefreshing,
}



// WEBPACK FOOTER //
// ./resources/assets/js/services/AuthService.js